import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';
import './navdropdown.css';
import logo from '../assests/logo.png';

const Header = () => {
  const { pathname } = useLocation();

  const isLinkActive = (path, exact = false) => {
    if (exact) return pathname === path;
    return pathname === path;
  };

  const linkClass = (path, exact = false) =>
    isLinkActive(path, exact) ? 'nav-link nav-link-active active' : 'nav-link';

  const isQualityActive =
    pathname === '/qualitypolicy' || pathname === '/qualitycertification';

  const dropdownItemClass = (path) =>
    pathname === path ? 'active-nav-item active' : '';

  return (
    <header>
      <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect className="site-navbar">
        <Container>
          <Navbar.Brand>
            <NavLink to="/">
              <img src={logo} alt="DecalTech" className="logo site-logo" />
            </NavLink>
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={NavLink} to="/" end className={linkClass('/', true)}>
                Home
              </Nav.Link>

              <Nav.Link as={NavLink} to="/aboutus" className={linkClass('/aboutus')}>
                About Us
              </Nav.Link>

              <NavDropdown
                title="Quality"
                id="quality-dropdown"
                className={`no-caret ${isQualityActive ? 'nav-dropdown-active' : ''}`}
              >
                <NavDropdown.Item
                  as={NavLink}
                  to="/qualitypolicy"
                  className={dropdownItemClass('/qualitypolicy')}
                >
                  Quality Policy
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={NavLink}
                  to="/qualitycertification"
                  className={dropdownItemClass('/qualitycertification')}
                >
                  Quality Certification
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={NavLink} to="/products" className={linkClass('/products')}>
                Our Products
              </Nav.Link>

              <Nav.Link as={NavLink} to="/capabilities" className={linkClass('/capabilities')}>
                Our Capabilities
              </Nav.Link>

              <Nav.Link as={NavLink} to="/gallery" className={linkClass('/gallery')}>
                Gallery
              </Nav.Link>

              <Nav.Link
                as={NavLink}
                to="/contact"
                className={`nav-contact-btn site-cta-btn${isLinkActive('/contact') ? ' nav-contact-btn-active' : ''}`}
              >
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
